import { Box, Button, Typography } from '@mui/material'
import TableTAG from '../TableTAG'
import DescriptionIcon from '@mui/icons-material/Description'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import colors from '../../constants/colors'
import { ICasetypeQuestions, IQuestionV2, MainObject } from '../../store/reports/types'
import QuestionComponent from '../QuestionComponent'
import VictimFormQuestionComponent from '../Questions/VictimFormQuestionComponent'
import {
  Control,
  FieldValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormUnregister,
  
} from 'react-hook-form'
import { uploadInputZones } from '../UploadDropzone/types'
import { Dispatch, SetStateAction } from 'react'
import { IAnswerFiles } from './types'
import { resolveFileType } from '../AttachmentsCase/DataPart'
import OpenQuestionComponent from '../Questions/OpenQuestionComponent'
import CheckboxQuestionComponent from '../Questions/CheckboxQuestionComponent'
import SingleSelectQuestionComponent from '../Questions/SingleSelectQuestionComponent'
import NumberQuestionComponent from '../Questions/NumberQuestionComponent'
import DateQuestionComponent from '../Questions/DateQuestionComponent'
import OpenUnknowQuestionComponent from '../Questions/OpenUnknowQuestionComponent'
import MultipleSelectGroupQuestionComponent from '../Questions/MultipleSelectGroupQuestionComponent'
import ReporterFormQuestionComponent from '../Questions/ReporterFormQuestionComponent'


const boxStyle = { width: '10rem', height: '10rem' }
const iconStyle = { width: '100%', height: '100%', color: colors.TAG_PURPLE }
const iconBoxStyle = { width: '3.5rem', height: '3.5rem' }

const renderUploadedFiles = (
  selectedFiles: {
    attachments: any[] | string
    description?: string
    title?: string
    type: uploadInputZones
  }[],
  deleteFile: any,
  previewOnly: boolean,
) => {
  const dataToRender = selectedFiles
    .map(material => {
      if (material.type === uploadInputZones.TEXT_FIELD) return material
      return material.attachments
    })
    .flat()

  return (
    <TableTAG
      pagination={false}
      columns={[
        {
          id: 'preview',
          label: 'Preview',
          format: (_: any, row: any) => {
            let url = ''
            if (row instanceof File) {
              url = URL.createObjectURL(row)
            }

            const getBoxStyle = (iconStyle: any) => <Box sx={[boxStyle]}>{iconStyle}</Box>

            const type  = resolveFileType(row?.name ? `.${row.name.split('.').pop()}` : '')
            const getMediaElement = (src: string) => (
              <img src={src} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
            )

            if (type === uploadInputZones.TEXT_FIELD || type === uploadInputZones.DOCUMENT) {
              return getBoxStyle(<TextFieldsIcon sx={[iconStyle]} />)
            }

            if (row?.type?.includes('text/') || row?.type?.includes('aplication/')) {
              return (
                <Box sx={{ width: '10rem', height: '10rem' }}>
                  {row?.link ? <a href={row?.link} target="_blank" rel="noreferrer"><DescriptionIcon sx={[iconStyle]} /></a> : <DescriptionIcon sx={[iconStyle]} />}
                  
                </Box>
              )
            }

            
            if (type === uploadInputZones.AUDIO) {
              return (
                <Box sx={[iconBoxStyle]}>
                  <AudioFileIcon fontSize='large' style={{ fill: colors.TAG_PURPLE }} />
                </Box>
              )
            }

            if (type === uploadInputZones.VIDEO) {
              return (
                <Box sx={[boxStyle]} id='video'>
                  <video style={{ objectFit: 'cover', width: '100%', height: '100%' }}>
                    <source src={row instanceof File ? url : row?.link}></source>
                  </video>
                </Box>
              )
            }

            return getBoxStyle(getMediaElement(row instanceof File ? url : row?.link))
          },
        },
        {
          id: 'name',
          label: 'File Name',
          format: (_: any, row: any) => {
            return (
              <Box sx={{ overflow: 'hidden', maxWidth: '80%', textOverflow: 'ellipsis' }}>
                {row?.name}
              </Box>
            )
          },
        },
        // {
        //   id: 'type',
        //   label: 'File Type',
        //   format: (_: any, row: any) => {
        //     return <Box sx={{ overflow: 'hidden' }}>{row?.extension ?? ''}</Box>
        //   },
        // },
        {
          id: 'editFile',
          label: 'Edit File',
          format: (_: any, row: any) => {
            return (
              <Box>
                <Button
                  onClick={e => {
                    e.preventDefault()
                    deleteFile(row?.id ? row?.id : row?.name)
                  }}
                  variant='outlined'
                  disabled={previewOnly}
                >
                  <Typography variant='bodyRegular' color='inherit'>
                    Delete
                  </Typography>
                </Button>
              </Box>
            )
          },
        },
      ]}
      rows={dataToRender}
    />
  )
}

const singleSelectHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  // return (
  //   <QuestionComponent
  //     question={question.text || question.text_third || question.label}
  //     questionId={question.id}
  //     questionUUID={question.uuid}
  //     questionOptions={question?.options}
  //     control={control}
  //     fieldName={question.uuid}
  //     unregister={unregister}
  //     setValue={setValue}
  //     key={`${question.uuid}`}
  //     setAnswersFiles={setAnswersFiles}
  //     answers={answers}
  //     previewOnly={previewOnly}
  //   />
  // )
  return (
    <SingleSelectQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
}

const victimFormHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <VictimFormQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const openHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <OpenQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const openUnknowHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <OpenUnknowQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const checkboxHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <CheckboxQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const numberHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <NumberQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}


const dateHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <DateQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const multipleSelectGroupQuestionHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <MultipleSelectGroupQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}

const formReporterHandler = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  return (
    <ReporterFormQuestionComponent
      questionObj={question}
      question={question.text || question.text_third || question.label}
      questionId={question.id}
      questionUUID={question.uuid}
      questionOptions={question?.options}
      control={control}
      fieldName={question.uuid}
      unregister={unregister}
      setValue={setValue}
      key={`${question.uuid}`}
      setAnswersFiles={setAnswersFiles}
      answers={answers}
      parent={parent}
      previewOnly={previewOnly}
    />
  )
  
}



const questionTypes: { [key: string]: any } = {
  SINGLE_SELECT_VERTICAL: singleSelectHandler,
  SINGLE_SELECT: singleSelectHandler,
  OPEN: openHandler,
  OPEN_UNKNOW: openUnknowHandler,
  CHECKBOX: checkboxHandler,
  DATE: dateHandler,
  NUMBER: numberHandler,
  LOGICAL: singleSelectHandler,
  FORM_VICTIM: victimFormHandler,
  MULTIPLE_SELECT_GROUP: multipleSelectGroupQuestionHandler,
  FORM_REPORTER: formReporterHandler
}

const questionParser = (
  question: IQuestionV2,
  control: Control,
  unregister: UseFormUnregister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  setAnswersFiles: Dispatch<SetStateAction<IAnswerFiles[]>>,
  answers?: MainObject[],
  parent?: any,
  previewOnly?: boolean,
) => {
  const questionVariantType = question?.variant?.type
  if (questionVariantType in questionTypes) {
    return questionTypes[questionVariantType](
      question,
      control,
      unregister,
      setValue,
      setAnswersFiles,
      answers,
      parent,
      previewOnly,
    )
  }
  return <></>
}

/* eslint-disable */
function transformStructure(structure: any, caseType: string, subOptionId = undefined) {
  const transformed = {
    id: undefined,
    answer: {
      question: structure?.id,
      text: ' ',
    },
    options: [],
    subanswers: undefined,
    uuid: structure?.uuid,
    ...(subOptionId ? { option: subOptionId } : {}),
    caseType,
    victim: structure.victim
  }

  // If the structure has subquestions, transform them recursively
  if (structure?.subquestions?.length > 0) {
    transformed.subanswers = structure?.subquestions.map((subquestion: any) => {
      const optionId = structure?.options[subquestion?.option - 1]?.id
      return transformStructure(subquestion, caseType, optionId)
    })
  }

  return transformed
}

const getAnswersToCaseTypeQuestions = (questions: ICasetypeQuestions[]) => {
  const test1 = questions
    .map(item => {
      return item.questions.map(question => transformStructure(question, item.caseType))
    })
    .flat(1)
  return test1
}

const updateAnswersOptions = (arrayOfAnswers: any[], answerUuid: string, backAnswer: any) => {
  const updatedArray: { uuid: string; answer: { text: string }; subanswers?: any[] }[] =
    arrayOfAnswers.map(answer => {
      if (answer?.uuid === answerUuid) {
        let answerCopy = { ...answer }
        answerCopy.options = backAnswer?.options
        answerCopy.id = backAnswer?.id
        answerCopy.answer.files = backAnswer?.files
        answerCopy.answer.text = backAnswer?.answers[0]?.question_option?.text
        if (backAnswer?.answers[0]?.question_option?.id) {
          answerCopy.options = [backAnswer?.answers[0]?.question_option?.id]
        }

        if (backAnswer?.subanswers[0]?.id) {
          answerCopy.subanswers[0].id = backAnswer?.subanswers[0]?.id
          answerCopy.subanswers[0].answer.text = backAnswer?.subanswers[0]?.text
        }

        return {
          ...answerCopy,
        }
      } else if (answer?.subanswers) {
        return {
          ...answer,
          subanswers: updateAnswersOptions(answer?.subanswers, answerUuid, backAnswer),
        }
      }

      return answer
    })

  return updatedArray
}

export default {
  renderUploadedFiles,
  questionParser,
  getAnswersToCaseTypeQuestions,
  transformStructure,
  updateAnswersOptions,
}
